const DynamicArticleRoutes = function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("dynamicArticle", {
        url: "/articles/*name",
        controller: "DynamicArticleRoutingController",
        templateUrl: function (params) {
            const dirPath = params.name;
            const dirs = dirPath.split("/");

            let url = __styleEnv__ + "customizations/Default/articles/" + dirs[0] + ".html";

            if (dirs.length > 1) {
                url = __styleEnv__ + "customizations/" + dirs[0] + "/articles/" + dirs[1] + ".html";
            }

            return url;
        },
        data: {
            fullHeight: true,
            title: "dynamic"
        }
    });
};

DynamicArticleRoutes.$inject = ["$stateProvider", "$urlRouterProvider"];
export default DynamicArticleRoutes;
